import * as Cookies from "es-cookie"
import { editDcmRetUrl } from "utils/gaMedia"

const useReturnToService = () => {
  // Default
  const defaultDcmRetUrl = "https://www.docomo.ne.jp/"
  // Cookie
  const cookieDcmRetUrl = Cookies.get("dcmRetUrl")
  // ServiceUrl
  const dcmRetUrl = cookieDcmRetUrl || defaultDcmRetUrl

  const sleep = sec => new Promise(resolve => setTimeout(resolve, sec * 1000))

  const returnToService = async () => {
    Cookies.remove("dcmRetUrl")
    const asrm = cookieDcmRetUrl ? decodeURIComponent(dcmRetUrl) : "/"
    const asrmg = cookieDcmRetUrl ? editDcmRetUrl(dcmRetUrl) : "/"

    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: "AgreementSelection-ReturnMedia",
      AgreementSelectionReturnMedia: asrm,
      AgreementSelectionReturnMediaGroup: asrmg,
    })
    await sleep(0.2)

    window.location.href = dcmRetUrl
  }
  const returnLabel =
    dcmRetUrl === defaultDcmRetUrl ? "NTTドコモ ホーム画面へ" : "サービスに戻る"
  return [returnToService, returnLabel]
}

export default useReturnToService
